import * as fromUser from '../actions/user.action';
import * as fromOrder from '../actions/order.action';

export interface IActivePromotionState {
    user: {
        loaded: boolean;
        loading: boolean;
        user: any;
    },
    order: {
        uuid: string;
    }
}

export const initialState: IActivePromotionState = {
    user: {
        loaded: false,
        loading: false,
        user: {}
    },
    order: {
        uuid: ""
    }
};


export function reducer(state: IActivePromotionState = initialState, action: any): IActivePromotionState {
    let target: any;
    switch (action.type) {
        case fromUser.ActionTypes.LOAD_USER:
            target = Object.assign({}, state.user, {loading: true});
            return Object.assign({}, state, {user: target});
        case fromUser.ActionTypes.LOAD_USER_SUCCESS:
            target = Object.assign({}, state.user, {
                loaded: true,
                loading: false,
                user: action.payload
            });
            return Object.assign({}, state, {user: target});
        case fromUser.ActionTypes.LOAD_USER_FAILURE:
            target = Object.assign({}, state.user, {
                loaded: true,
                loading: false,
                user: {}
            });
            return Object.assign({}, state, {user: target});
        case fromOrder.ActionTypes.SET_UUID:
            target = Object.assign({}, state.order, {uuid: action.payload});
            return Object.assign({}, state, {order: target});
        default:
            return state;
    }
}

export const getUser = (state: IActivePromotionState) => state.user;
